import { queryOptions } from "@tanstack/react-query";

import { listGatewaysForOrg } from "../api/endpoints/sensors";
import { callOptionsHeaders } from "../api/helpers";

type GatewaysOptionsParams = {
  regionCode: string;
  roleId: string;
};

export function gatewaysOptions({ regionCode, roleId }: GatewaysOptionsParams) {
  return queryOptions({
    queryKey: ["gateways", regionCode, roleId],
    queryFn: () =>
      listGatewaysForOrg(
        { orgId: roleId },
        callOptionsHeaders(regionCode, roleId),
      ),
    staleTime: 60 * 1000,
  });
}
